module.exports = __webpack_public_path__ + "img/defence-24-com.d88656ef.svg";